module.exports = __webpack_public_path__ + "img/home.2422f569.svg";